<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('accountDelete.details.type') }}</label></td>
      <td>{{ details.type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('accountDelete.details.account_id') }}</label></td>
      <td>{{ details.account_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.createdBy') }}</label></td>
      <td>{{ details.created_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updatedBy') }}</label></td>
      <td>{{ details.modified_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.status') }}</label></td>
      <td>{{ details.status }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('accountDelete.details.description') }}</label></td>
      <td><description-or-link :description="details.description"/></td>
    </tr>
    <tr v-if="details.status == 'canceled'">
      <td><label>{{ $t('accountDelete.details.cancel_description') }}</label></td>
      <td><description-or-link :description="details.cancel_description"/></td>
    </tr>
    <tr v-if="details.status == 'done'">
      <td><label>{{ $t('accountDelete.details.remaining_balance') }}</label></td>
      <td>
        <span v-if="details.remaining_balance">{{ details.remaining_balance | price}}</span>
      </td>
    </tr>
  </table>
</template>
<script>
  import DescriptionOrLink from "src/components/Description/DescriptionOrLink"
  export default {
    name: 'accountDeletionDetails',
    components: {
      DescriptionOrLink,
    },
    props: {
      details: {
        type: Object,
        required: true,
      }
    }
  };
</script>
<style></style>
